var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("v-select-dropdown", {
    attrs: { items: _vm.items, selectedItems: _vm.selectedItems },
    on: { onItemSelected: _vm.onClick },
    scopedSlots: _vm._u([
      {
        key: "header",
        fn: function(ref) {
          var active = ref.active
          return [
            active ? _c("span", [_vm._v(_vm._s(active.faqCategory))]) : _vm._e()
          ]
        }
      },
      {
        key: "item",
        fn: function(ref) {
          var item = ref.item
          return [_vm._v(_vm._s(item.faqCategory))]
        }
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }